<script setup>
import SectionTitle from '@weathernews/btos-vuecomponent/with-onebox-common-elements/src/components/SectionTitle.vue'

const linkList = [
  'ishikarigawa',
  'omonogawa',
  'mogamigawa',
  'kitakamigawa',
  'tonegawa',
  'arakawa_1',
  'tamagawa_2',
  'shinanogawa',
  'kisogawa',
  'tenryuugawa',
  'shounaigawa',
  'yodogawa',
  'gounokawa',
  'yoshinogawa',
  'chikugogawa',
  'kumagawa'
]

const prefText = (list) => {
  return list
    .filter(Boolean)
    .map((p) => p.replace(/[都府県]$/, ''))
    .join('・')
}
</script>

<template>
  <section class="riverLinks">
    <div class="head">
      <SectionTitle title="主要河川の水位情報" />
    </div>
    <div class="content">
      <NuxtLink
        v-for="(item, index) in linkList"
        :key="index"
        :href="`/${item}`"
        class="link"
      >
        {{ pageConfig[item].name }}（{{ prefText(pageConfig[item].pref_list) }}）
      </NuxtLink>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.riverLinks {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    border-radius: 6px;
    background-color: #EEF1F8;
  }
  .link {
    padding: 7px 10px;
    border-radius: 4px;
    background-color: #FFF;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / .15);
    color: #303030;
    font-size: 13px;
    font-weight: 600;
    line-height: 1em;
  }
  @media (any-hover: hover) {
    .link {
      transition: opacity .2s ease-in-out;
      cursor: pointer;
      &:hover {
        opacity: .6;
      }
    }
  }
}
.main {
  .riverLinks {
    @media (min-width: 830px) {
    }
  }
}
</style>
